import { FranchiseDetail } from "../../../../Interface/scheduler/form";
import { WebLocationsAPI } from "../../../../service/apiService";

export const EARTH_RADIUS_KM = 6378.1;
export const MILES_TO_KM = 1.60934;

export function degreeToRadius(degree: number): number {
  return degree * (Math.PI / 180);
}

export function radiusToDegree(radius: number): number {
  return (180 * radius) / Math.PI;
}

export function convertRange(franchiseLimit: number, units: string): number {
  if (units.includes("miles")) {
    return Math.round(franchiseLimit * MILES_TO_KM);
  }
  return franchiseLimit;
}

export function milesToKilometers(limit: number): number {
  return Math.round(limit * 1.60934);
}

export async function getAllLocations(Concept_code, formValues) {
  try {
    const res = await WebLocationsAPI(Concept_code, formValues);
    return res.data;
  } catch (e) {
    console.log("Error", e);
  }
}

export function filterResults(
  bbox: H.geo.Rect,
  franchiseDetails: FranchiseDetail[],
  pinnedWeblocationId: number
) {
  const distanceTo = JSON.parse(sessionStorage.getItem("distanceTo") as string);
  const currFranchiseDetails = [];
  franchiseDetails.forEach((fr) => {
    const isInBox = bbox.containsLatLng(fr.latitude, fr.longitude);
    const isPinned = pinnedWeblocationId === fr.franchiseWebLocationId;
    if (isInBox || isPinned) {
      fr.distance = getDistanceFromLatLon(
        distanceTo.lat,
        distanceTo.lng,
        fr.latitude,
        fr.longitude
      );
      currFranchiseDetails.push(fr);
    }
  });
  if (currFranchiseDetails.length === 1) {
    return currFranchiseDetails;
  } else if (currFranchiseDetails.length > 1) {
    return currFranchiseDetails;
  } else {
    console.error(`Could not find a location within range`);
    return currFranchiseDetails;
  }
}

export function getDistanceFromLatLon(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
  units: string = "miles"
): number {
  if (lat1 === lat2 && lon1 === lon2) return 0;
  const radlat1 = degreeToRadius(lat1);
  const radlat2 = degreeToRadius(lat2);
  const theta = lon1 - lon2;
  const radtheta = degreeToRadius(theta);
  let dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(Math.min(dist, 1)) * (180 / Math.PI) * 60 * 1.1515;
  return units === "km" ? dist * 1.609344 : dist;
}

export function getBoundingBox(
  fsLatitude: number,
  fsLongitude: number,
  fiDistanceInKM: number
): number[] {
  if (
    fiDistanceInKM == null ||
    fiDistanceInKM == undefined ||
    fiDistanceInKM == 0
  ) {
    fiDistanceInKM = 1;
  }

  const MIN_LAT = degreeToRadius(-90);
  const MAX_LAT = degreeToRadius(90);
  const MIN_LON = degreeToRadius(-180);
  const MAX_LON = degreeToRadius(180);

  const ldEarthRadius = EARTH_RADIUS_KM;
  const ldDistanceInRadius = fiDistanceInKM / ldEarthRadius;

  const lsLatitudeInDegree = fsLatitude;
  const lsLongitudeInDegree = fsLongitude;

  const lsLatitudeInRadius = degreeToRadius(lsLatitudeInDegree);
  const lsLongitudeInRadius = degreeToRadius(lsLongitudeInDegree);

  let lsMinLatitude = lsLatitudeInRadius - ldDistanceInRadius;
  let lsMaxLatitude = lsLatitudeInRadius + ldDistanceInRadius;

  let lsMinLongitude: number | undefined;
  let lsMaxLongitude: number | undefined;

  const deltaLon = Math.asin(
    Math.sin(ldDistanceInRadius) / Math.cos(lsLatitudeInRadius)
  );

  if (lsMinLatitude > MIN_LAT && lsMaxLatitude < MAX_LAT) {
    lsMinLongitude = lsLongitudeInRadius - deltaLon;
    lsMaxLongitude = lsLongitudeInRadius + deltaLon;

    if (lsMinLongitude < MIN_LON) {
      lsMinLongitude += 2 * Math.PI;
    }
    if (lsMaxLongitude > MAX_LON) {
      lsMaxLongitude -= 2 * Math.PI;
    }
  } else {
    lsMinLatitude = Math.max(lsMinLatitude, MIN_LAT);
    lsMaxLatitude = Math.min(lsMaxLatitude, MAX_LAT);
    lsMinLongitude = MIN_LON;
    lsMaxLongitude = MAX_LON;
  }

  return [
    radiusToDegree(lsMinLatitude),
    radiusToDegree(lsMinLongitude as number),
    radiusToDegree(lsMaxLatitude),
    radiusToDegree(lsMaxLongitude as number),
  ];
}

export function findUnits(area_measure_values: string): string {
  if (area_measure_values?.includes("measure_km")) {
    return "km";
  }
  return "miles";
}
